import { createError } from '@adv-frontend/error';

export const registeredForms = new Set<string>();

export const FormAlreadyRegisteredError = createError<{ name: string }>('FormAlreadyRegisteredError');
